/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit ListItems.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import FirstName from './FirstName/view.js'
import LastName from './LastName/view.js'
import React from 'react'
import Role from './Role/view.js'
import useIsHovered from 'Logic/useIsHovered.js'
import { css } from "emotion"

let styles = {}
styles.Card = css({label: 'Card',
  flexDirection: "row",
height: 70,
position: "absolute",
alignItems: "center",
borderStyle: "solid",
borderWidth: 1,
cursor: "pointer",
marginTop: 8,
paddingBottom: 8,
paddingLeft: 20,
paddingRight: 20,
paddingTop: 8,
overflowY: "hidden",
overflowX: "hidden",
userSelect: "none",
  
transition: 'background-color 150ms ease-in-out, border-color 150ms ease-in-out',
willChange: 'background-color, border-color',
  left: 'var(--left)',
top: 'var(--top)',
width: 'var(--width)',
backgroundColor: 'var(--backgroundColor)',
borderBottomLeftRadius: 'var(--borderBottomLeftRadius)',
borderBottomRightRadius: 'var(--borderBottomRightRadius)',
borderColor: 'var(--borderColor)',
borderTopLeftRadius: 'var(--borderTopLeftRadius)',
borderTopRightRadius: 'var(--borderTopRightRadius)'})

export default function ListItems({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  left= 0,
top= 0,
width= "100%",
borderBottomLeftRadius= 6,
borderBottomRightRadius= 6,
borderTopLeftRadius= 6,
borderTopRightRadius= 6,
onClick,
isSelected,
viewPath= "/App/MyAccount/Content/Profile/Content/Admins/ListItems"
}) {
    
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
    
    
    
    

  return (<React.Fragment
>
<button
 data-testid="ListItems.Card"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/ListItems"
 {...isHoveredBind}
 onClick={onClick}
 style={{'--left': typeof left === 'number' ? `${left}px` : left,'--top': typeof top === 'number' ? `${top}px` : top,'--width': typeof width === 'number' ? `${width}px` : width,'--borderBottomLeftRadius': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--borderBottomRightRadius': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--borderTopLeftRadius': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--borderTopRightRadius': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--backgroundColor': isSelected ? "rgba(0,207,104, 0.1)" : isHovered ? "rgba(0,207,104, 0.15)" : "rgba(255,255,255,0.5)",'--borderColor': isSelected ? "rgba(0,207,104, 0.2)" : isHovered ? "rgba(0,207,104, 0.0)" : "#f2f2f2"}}
 className={`views-block ${styles.Card}`}
>
<LastName
 data-testid="ListItems.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/ListItems"
viewPath={`${viewPath}/LastName`}
 isHovered={isHovered}
/>
<FirstName
 data-testid="ListItems.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/ListItems"
viewPath={`${viewPath}/FirstName`}
 isHovered={isHovered}
/>
<Role
 data-testid="ListItems.Role"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/ListItems"
viewPath={`${viewPath}/Role`}
 isHovered={isHovered}
/>
</button>
{children}
</React.Fragment>)
}